// Sidebar menu config — declarative translation of legacy Sidebar.js.
// Path adjustment: original file imported from "../assets/...".
// This file lives one level deeper (sharedComponent/Sidebar/), so paths
// are rewritten to "../../assets/...".

import dashboard_icon from "../../assets/images/sidebar/icons/dashboard.svg";
import dashboard_icon_active from "../../assets/images/sidebar/icons/dashboard_active.svg";

import comm_icon_Dark from "../../assets/images/sidebar/icons/communcationDark.svg";
import comm_icon_active from "../../assets/images/sidebar/icons/communcation.svg";

import attendance_icon from "../../assets/images/sidebar/icons/attendance.svg";
import attendance_icon_active from "../../assets/images/sidebar/icons/attendance_active.svg";

import Compliance from "../../assets/images/sidebar/icons/ComplianceIcon.svg";
import ComplianceActive from "../../assets/images/sidebar/icons/ComplianceActiveIcon.svg";

import EmployeeManagementIcon from "../../assets/images/sidebar/icons/EmployeeManagementIcon.svg";
import EmployeeManagementActiveIcon from "../../assets/images/sidebar/icons/EmployeeManagementActiveIcon.svg";

import Organ_Dark from "../../assets/images/sidebar/icons/OrganDark.svg";
import Organ_active from "../../assets/images/sidebar/icons/Organ.svg";

import ProjectMan_Dark from "../../assets/images/sidebar/icons/ProjectManDark.svg";
import ProjectMan_active from "../../assets/images/sidebar/icons/ProjectMan.svg";

import TeamsManagementIcon from "../../assets/images/sidebar/icons/TeamsManagementIcon.svg";
import TeamsManagementActiveIcon from "../../assets/images/sidebar/icons/TeamsManagementActiveIcon.svg";

import taskmanag_icon from "../../assets/images/sidebar/icons/taskmanag.svg";
import taskmanag_icon_active from "../../assets/images/sidebar/icons/taskmanag_active.svg";

import timesheet_icon from "../../assets/images/sidebar/icons/timesheet.svg";
import timesheet_icon_active from "../../assets/images/sidebar/icons/timesheet_active.svg";

import Bot from "../../assets/images/sidebar/icons/bot.png";

import ClientMan from "../../assets/images/sidebar/clientMan.svg";
import ClientManActive from "../../assets/images/sidebar/clientManActive.svg";

import CRMOfficeCaller_active from "../../assets/images/CRMOfficecaller_active..svg";
import CRMphone_iactive from "../../assets/images/sidebar/CRMPhonebook.svg";

import ActiveMan from "../../assets/images/userActive.svg";

import wallet from "../../assets/images/wallet.svg";
import walletActive from "../../assets/images/walletActive.svg";

import invent from "../../assets/images/inventoryMgt.svg";
import inventactive from "../../assets/images/inventoryMgtActive.svg";
import menulist from "../../assets/images/menulist.svg";
import menulistactive from "../../assets/images/menulistactive.svg";
import orderlist from "../../assets/images/orderlisting.svg";
import orderlistactive from "../../assets/images/orderlistingactive.svg";
import storemgt from "../../assets/images/storemgt.svg";
import storemgtactive from "../../assets/images/storemgtactive.svg";
import stock from "../../assets/images/stock.svg";
import stockactive from "../../assets/images/stockactive.svg";

// Bot-admin icons
import unAns from "../../assets/images/icons/question-list.svg";
import queList from "../../assets/images/icons/Layer 3.svg";
import addQue from "../../assets/images/icons/add-circle.svg";
import setting from "../../assets/images/icons/setting.svg";
import accesscode from "../../assets/images/icons/message-programming.svg";
import traineeQue from "../../assets/images/icons/Frame 699.svg";
import convFlow from "../../assets/images/icons/Frame 703.svg";
import coversations from "../../assets/images/icons/user (1).svg";

import unAns1 from "../../assets/images/icons/un-anslist.svg";
import queList1 from "../../assets/images/icons/questionlist.svg";
import addQue1 from "../../assets/images/icons/addQue.svg";
import setting1 from "../../assets/images/icons/setting (2).svg";
import accesscode1 from "../../assets/images/icons/access.svg";
import traineeQue1 from "../../assets/images/icons/trainingQue.svg";
import convFlow1 from "../../assets/images/icons/conversationflow.svg";
import coversations1 from "../../assets/images/icons/conversations.svg";

// Task / attendance / project / team icons
import task from "../../assets/images/icons/taskk.svg";
import task1 from "../../assets/images/icons/taskk-1.svg";
import tasklist from "../../assets/images/icons/tasklist.svg";
import tasklist1 from "../../assets/images/icons/tasklist-1.svg";
import myattend from "../../assets/images/icons/attendance.svg";
import myattend1 from "../../assets/images/icons/attendance-1.svg";
import subordatt from "../../assets/images/icons/subordinateattend.svg";
import subordatt1 from "../../assets/images/icons/subordinateattend-1.svg";
import applyleave from "../../assets/images/icons/applyleave.svg";
import applyleave1 from "../../assets/images/icons/applyleave-1.svg";
import leavesett from "../../assets/images/icons/leavesetting.svg";
import leavesett1 from "../../assets/images/icons/leavesetting-1.svg";
import apprvtask from "../../assets/images/icons/approvetask.svg";
import apprvtask1 from "../../assets/images/icons/approvetask-1.svg";
import facedet from "../../assets/images/icons/facedet.svg";
import facedet1 from "../../assets/images/icons/facedet-1.svg";
import usertracking from "../../assets/images/icons/usertacking.svg";
import usertracking1 from "../../assets/images/icons/usertracking-1.svg";
import branchattend from "../../assets/images/icons/branchattend.svg";
import branchattend1 from "../../assets/images/icons/branchattend-1.svg";
import prj from "../../assets/images/icons/prj.svg";
import prj1 from "../../assets/images/icons/prj-1.svg";

import team from "../../assets/images/icons/team.svg";
import team1 from "../../assets/images/icons/team-1.svg";
import agent from "../../assets/images/icons/agent.svg";
import agent1 from "../../assets/images/icons/agent-1.svg";
import calls from "../../assets/images/icons/calls.svg";
import calls1 from "../../assets/images/icons/calls-1.svg";
import notcall from "../../assets/images/icons/notcall.svg";
import notcall1 from "../../assets/images/icons/notcall-1.svg";
import rawdata from "../../assets/images/icons/rawdata.svg";
import rawdata1 from "../../assets/images/icons/rawdata-1.svg";
import freqcall from "../../assets/images/icons/freqcaller.svg";
import freqcall1 from "../../assets/images/icons/freqcaller-1.svg";
import candi from "../../assets/images/icons/candi.svg";
import candi1 from "../../assets/images/icons/candi-1.svg";

import prjcostRep from "../../assets/images/icons/prjCostRep.svg";
import prjcostRep1 from "../../assets/images/icons/prjCostRep-1.svg";
import manageTeam from "../../assets/images/icons/manageTeam.svg";
import manageTeam1 from "../../assets/images/icons/manageTeam-1.svg";
import addTeam from "../../assets/images/icons/addTeam.svg";
import addTeam1 from "../../assets/images/icons/addTeam-1.svg";
import holidays from "../../assets/images/icons/holidays.svg";
import holidays1 from "../../assets/images/icons/holidays-1.svg";
import announcement from "../../assets/images/icons/announcement.svg";
import announcement1 from "../../assets/images/icons/announcement-1.svg";
import prjtimesheet from "../../assets/images/icons/prjTimesheetDet-1.svg";
import prjtimesheet1 from "../../assets/images/icons/prjTimesheetDet.svg";
import prjss from "../../assets/images/icons/prjs.svg";
import prjss1 from "../../assets/images/icons/prjs-1.svg";
import prjAlloc from "../../assets/images/icons/prjAllocation.svg";
import prjAlloc1 from "../../assets/images/icons/prjAllocation-1.svg";
import prjres from "../../assets/images/icons/prjResources.svg";
import prjres1 from "../../assets/images/icons/prjResources-1.svg";
import prjschedule from "../../assets/images/icons/prjschedule.svg";
import prjschedule1 from "../../assets/images/icons/prjschedule-1.svg";
import prjdoc1 from "../../assets/images/icons/prjdoc-1.svg";
import prjdoc from "../../assets/images/icons/prjdoc.svg";
import prjtask from "../../assets/images/icons/prjtask.svg";
import prjtask1 from "../../assets/images/icons/prjtask-1.svg";
import completetask from "../../assets/images/icons/completedtask.svg";
import completetask1 from "../../assets/images/icons/completedtask-1.svg";
import holdtask from "../../assets/images/icons/holdtask.svg";
import holdtask1 from "../../assets/images/icons/holdtask-1.svg";
import aborttask from "../../assets/images/icons/aborttask.svg";
import aborttask1 from "../../assets/images/icons/aborttask-1.svg";
import taskalloc from "../../assets/images/icons/taskAllocation.svg";
import taskalloc1 from "../../assets/images/icons/taskAllocation-1.svg";
import clientmgt from "../../assets/images/icons/clientMgt.svg";
import clientmgt1 from "../../assets/images/icons/clientMgt-1.svg";
import role from "../../assets/images/icons/role.svg";
import role1 from "../../assets/images/icons/role-1.svg";
import contactgrpmgt from "../../assets/images/icons/contactGrpMgt.svg";
import contactgrpmgt1 from "../../assets/images/icons/contactGrpMgt-1.svg";
import domapp from "../../assets/images/icons/domains&app.svg";
import domapp1 from "../../assets/images/icons/domains&app-1.svg";
import admin from "../../assets/images/icons/admin.svg";
import admin1 from "../../assets/images/icons/admin-1.svg";
import querymgt from "../../assets/images/icons/queryMgt.svg";
import querymgt1 from "../../assets/images/icons/queryMgt-1.svg";
import leads from "../../assets/images/icons/leads.svg";
import leads1 from "../../assets/images/icons/leads-1.svg";
import whtsapppromo from "../../assets/images/icons/whatsPromo.svg";
import whtsapppromo1 from "../../assets/images/icons/whatsPromo-1.svg";
import supplier from "../../assets/images/icons/supplier.svg";
import supplier1 from "../../assets/images/icons/supplier-1.svg";
import consultant from "../../assets/images/icons/consultant.svg";
import consultant1 from "../../assets/images/icons/consultant-1.svg";
import servicereq from "../../assets/images/icons/serviceReq.svg";
import servicereq1 from "../../assets/images/icons/serviceReq-1.svg";
import salesinter from "../../assets/images/icons/salesInternational.svg";
import salesinter1 from "../../assets/images/icons/salesInternational-1.svg";
import whtsappsett11 from "../../assets/images/icons/whtsppsett-1.svg";
import whtsappsettt from "../../assets/images/icons/whtsappsett.svg";
import timesheetentry from "../../assets/images/icons/timesheetentry.svg";
import timesheetentry1 from "../../assets/images/icons/timesheetentry-1.svg";
import emptimedet from "../../assets/images/icons/empTimedet.svg";
import emptimedet1 from "../../assets/images/icons/empTimedet-1.svg";
import timesheetapp from "../../assets/images/icons/timesheetapp.svg";
import timesheetapp1 from "../../assets/images/icons/timesheetapp-1.svg";
import emplist from "../../assets/images/icons/empList.svg";
import emplist1 from "../../assets/images/icons/empList-1.svg";
import addemp from "../../assets/images/icons/addEmp.svg";
import addemp1 from "../../assets/images/icons/addEmp-1.svg";
import timesheethis from "../../assets/images/icons/timesheethis.svg";
import timesheethis1 from "../../assets/images/icons/timesheethis-1.svg";
import paymentgat from "../../assets/images/icons/paymentgat.svg";
import paymentgat1 from "../../assets/images/icons/paymentgat-1.svg";
import ivrsett from "../../assets/images/icons/ivrsetting.svg";
import ivrsett1 from "../../assets/images/icons/ivrsetting-1.svg";
import empcode from "../../assets/images/icons/empcode.svg";
import empcode1 from "../../assets/images/icons/empcode-1.svg";
import teamnotassigned from "../../assets/images/icons/teamnotassign.svg";
import teamnotassigned1 from "../../assets/images/icons/teamnotassign-1.svg";
import tasknotadd from "../../assets/images/icons/tasknotadd.svg";
import tasknotadd1 from "../../assets/images/icons/tasknotadd-1.svg";
import usernotlogin from "../../assets/images/icons/usernotlogin.svg";
import usernotlogin1 from "../../assets/images/icons/usernotlogin-1.svg";
import salarystr from "../../assets/images/icons/salarystr.svg";
import salarystr1 from "../../assets/images/icons/salarystr-1.svg";
import gensalslip from "../../assets/images/icons/gensalslip.svg";
import gensalslip1 from "../../assets/images/icons/gensalslip-1.svg";
import empDoc from "../../assets/images/icons/empDoc.svg";
import empDoc1 from "../../assets/images/icons/empDoc-1.svg";
import empattrep from "../../assets/images/icons/empattrep.svg";
import empattrep1 from "../../assets/images/icons/empattrep-1.svg";
import atthis from "../../assets/images/icons/attenhis.svg";
import atthis1 from "../../assets/images/icons/attenhis-1.svg";
import users from "../../assets/images/icons/users.svg";
import users1 from "../../assets/images/icons/users-1.svg";
import agentcallsumm from "../../assets/images/icons/agentcallsumm.svg";
import agentcallsumm1 from "../../assets/images/icons/agentcallsumm-1.svg";
import invalidleads from "../../assets/images/icons/invalidlead.svg";
import invalidleads1 from "../../assets/images/icons/invalidlead-1.svg";
import emailrep from "../../assets/images/icons/emailrep.svg";
import emailrep1 from "../../assets/images/icons/emailrep-1.svg";
import campaign from "../../assets/images/icons/campaign.svg";
import campaign1 from "../../assets/images/icons/campaign-1.svg";
import pushnoti from "../../assets/images/icons/pushnotifi.svg";
import pushnoti1 from "../../assets/images/icons/pushnotifi-1.svg";
import googleana from "../../assets/images/icons/googleana.svg";
import googleana1 from "../../assets/images/icons/googleana-1.svg";
import website from "../../assets/images/icons/website.svg";
import website1 from "../../assets/images/icons/website-1.svg";
import prjnotassign from "../../assets/images/icons/prjnotassign.svg";
import prjnotassign1 from "../../assets/images/icons/prjnotassign-1.svg";
import tasknotapp from "../../assets/images/icons/tasknotapp.svg";
import tasknotapp1 from "../../assets/images/icons/tasknotapp-1.svg";
import timesheerperover from "../../assets/images/icons/timesheetperover.svg";
import timesheerperover1 from "../../assets/images/icons/timesheetperover-1.svg";
import benchlist from "../../assets/images/icons/benchlist.svg";
import benchlist1 from "../../assets/images/icons/benchlist-1.svg";
import complsett from "../../assets/images/icons/compliancesett.svg";
import complsett1 from "../../assets/images/icons/compliancesett-1.svg";
import download from "../../assets/images/icons/download.svg";
import download1 from "../../assets/images/icons/download-1.svg";
import callrep from "../../assets/images/icons/callrep.svg";
import callrep1 from "../../assets/images/icons/callrep-1.svg";
import chat from "../../assets/images/icons/chat.svg";
import chat1 from "../../assets/images/icons/chat-1.svg";
import domain from "../../assets/images/icons/domain.svg";
import domain1 from "../../assets/images/icons/domain-1.svg";
import categories from "../../assets/images/icons/categories.svg";
import categories1 from "../../assets/images/icons/categories-1.svg";
import apps from "../../assets/images/icons/apps.svg";
import apps1 from "../../assets/images/icons/app-1.svg";
import nonfuncfea from "../../assets/images/icons/nonfuncfea.svg";
import nonfuncfea1 from "../../assets/images/icons/nonfuncfea-1.svg";
import bulkupload from "../../assets/images/icons/bulkupload.svg";
import bulkupload1 from "../../assets/images/icons/bulkupload-1.svg";
import teamtask from "../../assets/images/icons/teamtask.svg";
import teamtask1 from "../../assets/images/icons/teamtask-1.svg";
import finyear from "../../assets/images/icons/finyear.svg";
import finyear1 from "../../assets/images/icons/finyear-1.svg";
import leaveappr from "../../assets/images/icons/leaveappr.svg";
import leaveappr1 from "../../assets/images/icons/leaveappr-1.svg";
import callassign from "../../assets/images/icons/callassign.svg";
import callassign1 from "../../assets/images/icons/callassign-1.svg";
import viewdata from "../../assets/images/icons/viewdata.svg";
import viewdata1 from "../../assets/images/icons/viewdata-1.svg";
import contactcusgrp from "../../assets/images/icons/contactcusgrp.svg";
import contactcusgrp1 from "../../assets/images/icons/contactcusgrp-1.svg";
import defgrp from "../../assets/images/icons/defaultgrp.svg";
import defgrp1 from "../../assets/images/icons/defaultgrp-1.svg";
import prjissues from "../../assets/images/icons/prjissue.svg";
import prjissues1 from "../../assets/images/icons/prjissue-1.svg";
import stdtask from "../../assets/images/icons/stdtask.svg";
import stdtask1 from "../../assets/images/icons/stdtask-1.svg";
import emppresentlist from "../../assets/images/icons/emppresentlist.svg";
import emppresentlist1 from "../../assets/images/icons/emppresentlist-1.svg";
import userlastlogin from "../../assets/images/icons/userlastlogin.svg";
import userlastlogin1 from "../../assets/images/icons/userlastlogin-1.svg";
import smspromo from "../../assets/images/icons/smspromo.svg";
import smspromo1 from "../../assets/images/icons/smspromo-1.svg";
import reguser from "../../assets/images/icons/reguser.svg";
import reguser1 from "../../assets/images/icons/reguser-1.svg";
import emptimesheetdet from "../../assets/images/icons/emptimesheerdet.svg";
import emptimesheetdet1 from "../../assets/images/icons/emptimesheerdet-1.svg";
import shiftmas from "../../assets/images/icons/shiftmaster.svg";
import shiftmas1 from "../../assets/images/icons/shiftmaster-1.svg";
import orginfo from "../../assets/images/icons/orginfo.svg";
import orginfo1 from "../../assets/images/icons/orginfo-1.svg";
import twoplusprj from "../../assets/images/icons/twoplusprj.svg";
import twoplusprj1 from "../../assets/images/icons/twoplusprj-1.svg";
import prjdeassign from "../../assets/images/icons/prjdeassign.svg";
import prjdeassign1 from "../../assets/images/icons/prjdeassign-1.svg";
import workflow from "../../assets/images/icons/workflow.svg";
import leadmgt from "../../assets/images/icons/leadmgt.svg";
import leadmgt1 from "../../assets/images/icons/leadmgt-1.svg";
import zerocall from "../../assets/images/icons/zerocall.svg";
import zerocall1 from "../../assets/images/icons/zerocall-1.svg";
import sendgrid from "../../assets/images/icons/sendgrid.svg";
import musterrole from "../../assets/images/icons/muster-roll.svg";
import musterrole1 from "../../assets/images/icons/muster-1.svg";
import reassign from "../../assets/images/icons/reassign.svg";
import reassign1 from "../../assets/images/icons/reassign-1.svg";
import settings from "../../assets/images/icons/settings.svg";
import settings1 from "../../assets/images/icons/settings-1.svg";
import filetextt from "../../assets/images/icons/filetextt.svg";
import filetextt1 from "../../assets/images/icons/filetextt1.svg";
import handd from "../../assets/images/icons/handd.svg";
import handd1 from "../../assets/images/icons/handd1.svg";
import chartaxess from "../../assets/images/icons/chartaxess.svg";
import chartaxess1 from "../../assets/images/icons/chartaxess1.svg";
import receiptt from "../../assets/images/icons/receiptt.svg";
import receiptt1 from "../../assets/images/icons/receiptt1.svg";
import slider from "../../assets/images/icons/slider.svg";
import slider1 from "../../assets/images/icons/slider1.svg";
import incoming from "../../assets/images/icons/incoming.svg";
import incoming1 from "../../assets/images/icons/incoming1.svg";

// Lucide-react icons used by the wallet sub-items
import {
  BarChart3,
  Users as UsersIcon,
  CreditCard,
  FileText,
  PauseCircle,
} from "lucide-react";

const sidebarMenuConfig = [
  // 1. Dashboard
  {
    key: "dashboard",
    label: "Dashboard",
    eventKey: "0",
    icon: { active: dashboard_icon_active, inactive: dashboard_icon },
    anyPermission: [
      "View Calendar",
      "My Task",
      "Alert Notification",
      "Timesheet",
      "Check In / Out",
    ],
    matches: ["/Dashboard"],
    type: "link",
    to: "/Dashboard",
  },

  // 2. Communication
  {
    key: "communication",
    label: "Communication",
    eventKey: "2",
    icon: { active: comm_icon_Dark, inactive: comm_icon_active },
    anyPermission: [
      "View Chat",
      "View Communication Projects",
      "View Teams",
      "View Calls",
      "View Ongoing Calls",
      "View Meetings",
    ],
    matches: [
      "/chat",
      "/projects",
      "/Call",
      "/teams",
      "/ongoing-calls",
      "/AllAnnouncement",
    ],
    badge: "unreadCount",
    type: "accordion",
    items: [
      {
        label: "Announcements",
        to: "/AllAnnouncement",
        icon: { active: announcement1, inactive: announcement },
        permission: "View All Announcement",
        matches: ["/AllAnnouncement", "/MyAnnouncement"],
      },
      {
        label: "Calls",
        to: "/Call",
        icon: { active: calls1, inactive: calls },
        permission: "View Calls",
        matches: ["/Call"],
        socketTrigger: "getCallHistory",
      },
      {
        label: "Chat",
        to: "/chat",
        icon: { active: chat1, inactive: chat },
        permission: "View Chat",
        matches: ["/chat"],
        socketTrigger: "getPrivateChat",
        badge: "chatCount",
      },
      {
        label: "Projects",
        to: "/projects",
        icon: { active: prj1, inactive: prj },
        permission: "View Communication Projects",
        matches: ["/projects"],
        socketTrigger: "getProjects",
        badge: "unreadProjectCount",
      },
      {
        label: "Teams",
        to: "/teams",
        icon: { active: team1, inactive: team },
        permission: "View Teams",
        matches: ["/teams"],
        socketTrigger: "getTeams",
        badge: "unreadTeamCount",
      },
      {
        label: "Ongoing Calls",
        to: "/ongoing-calls",
        icon: { active: incoming1, inactive: incoming },
        permission: "View Ongoing Calls",
        matches: ["/ongoing-calls"],
        socketTrigger: "getCallHistory",
      },
    ],
  },

  // 3. Attendance
  {
    key: "attendance",
    label: "Attendance",
    eventKey: "1",
    icon: { active: attendance_icon_active, inactive: attendance_icon },
    anyPermission: [
      "View My Attendance",
      "View Subordinates Attendance",
      "View Employee Attendance Report",
      "View Attendance History",
      "View Apply Leave",
      "View Approve Leave",
      "View Branch Attendance Report",
      "View User Face Detection",
      "View User Tracking",
    ],
    matches: [
      "/attendance",
      "/EmployeeAttendence",
      "/EmployeeAttendenceReport",
      "/DevicePunchHistory",
      "/LeaveApprove",
      "/Leave",
      "/AllEmployeeAttendanceReport",
      "/FaceDetection",
      "/LeaveSetting",
      "/UserTracking",
      "/employeeLeave",
    ],
    type: "accordion",
    items: [
      {
        label: "My Attendance",
        to: "/attendance",
        icon: { active: myattend1, inactive: myattend },
        permission: "View My Attendance",
        matches: ["/attendance"],
      },
      {
        label: "Attendance History",
        to: "/DevicePunchHistory",
        icon: { active: atthis1, inactive: atthis },
        permission: "View Attendance History",
        matches: ["/DevicePunchHistory"],
      },
      {
        label: "Apply Leave",
        to: "/Leave",
        icon: { active: applyleave1, inactive: applyleave },
        permission: "View Apply Leave",
        matches: ["/Leave"],
      },
      {
        label: "Apply Employee Leave",
        to: "/employeeLeave",
        icon: { active: applyleave1, inactive: applyleave },
        permission: "View Apply Employee Leave",
        matches: ["/employeeLeave"],
      },
      {
        label: "Approve Leave",
        to: "/LeaveApprove",
        icon: { active: leaveappr1, inactive: leaveappr },
        permission: "View Approve Leave",
        matches: ["/LeaveApprove"],
      },
      {
        label: "Branch Attendance Report",
        to: "/AllEmployeeAttendanceReport",
        icon: { active: branchattend1, inactive: branchattend },
        permission: "View Branch Attendance Report",
        matches: ["/AllEmployeeAttendanceReport"],
      },
      {
        label: "Employee Attendance Report",
        to: "/EmployeeAttendenceReport",
        icon: { active: empattrep1, inactive: empattrep },
        permission: "View Employee Attendance Report",
        matches: ["/EmployeeAttendenceReport"],
      },
      {
        label: "Face Detection",
        to: "/FaceDetection",
        icon: { active: facedet1, inactive: facedet },
        permission: "View User Face Detection",
        matches: ["/FaceDetection"],
      },
      {
        label: "Leave Setting",
        to: "/LeaveSetting",
        icon: { active: leavesett1, inactive: leavesett },
        permission: "View Leave Setting",
        matches: ["/LeaveSetting"],
      },
      {
        label: "Subordinates Attendance",
        to: "/EmployeeAttendence",
        icon: { active: subordatt1, inactive: subordatt },
        permission: "View Subordinates Attendance",
        matches: ["/EmployeeAttendence"],
      },
      {
        label: "User Tracking",
        to: "/UserTracking",
        icon: { active: usertracking1, inactive: usertracking },
        permission: "View User Tracking",
        matches: ["/UserTracking"],
      },
    ],
  },

  // 4. Ap & Procurement (Financial Management)
  {
    key: "apProcurement",
    label: "Ap & Procurement",
    eventKey: "26",
    icon: { active: receiptt1, inactive: receiptt },
    anyPermission: [
      "View Purchase Setting",
      "View Purchase Report",
      "View Priston Settings",
      "View Purchase Goods Invoice List",
      "View Purchase Service",
      "View Purchase Service Invoice List",
      "View Purchase Report",
    ],
    matches: [
      "/SalaryMasterRoll",
      "/SalaryStructure",
      "/SalaryStructureWizard",
      "/GenerateSalarySlip",
      "/purchaseGoods",
      "/purchase-goods-invoices",
      "/PurchaseServices",
      "/purchase-service-invoices",
      "/wallet/admin/dashboard",
      "/wallet/admin/users",
      "/wallet/admin/payouts",
      "/wallet/admin/settlements",
      "/wallet/admin/holds",
    ],
    type: "accordion",
    items: [
      {
        key: "apProcurement-purchase",
        label: "Purchase",
        eventKey: "26-purchase",
        type: "accordion",
        icon: { active: handd1, inactive: handd },
        anyPermission: [
          "View Purchase Goods",
          "View Purchase Service",
          "View Purchase Goods Invoice List",
          "Purchase Settings",
          "View Purchase Service Invoice List ",
        ],
        matches: [
          "/purchaseGoods",
          "/PurchaseServices",
          "/purchase-goods-invoices",
          "/purchase-service-invoices",
        ],
        items: [
          {
            label: "Goods",
            to: "/purchaseGoods",
            permission: "View Purchase Setting",
            matches: ["/purchaseGoods"],
          },
          {
            label: "Goods Invoice List",
            to: "/purchase-goods-invoices",
            permission: "View Purchase Goods Invoice List",
            matches: ["/purchase-goods-invoices"],
          },
          {
            label: "Service",
            to: "/PurchaseServices",
            permission: "View Purchase Service",
            matches: ["/PurchaseServices"],
          },
          {
            label: "Service Invoice List",
            to: "/purchase-service-invoices",
            permission: "View Purchase Service Invoice List",
            matches: ["/purchase-service-invoices"],
          },
        ],
      },
      {
        key: "apProcurement-payroll",
        label: "PayRoll",
        eventKey: "26-payroll",
        type: "accordion",
        icon: { active: teamnotassigned1, inactive: teamnotassigned },
        matches: [
          "/SalaryMasterRoll",
          "/SalaryStructure",
          "/SalaryStructureWizard",
          "/GenerateSalarySlip",
          "/HourlySalaryMusterRoll",
        ],
        items: [
          {
            label: "Salary Structure",
            to: "/SalaryStructure",
            icon: { active: salarystr1, inactive: salarystr },
            permission: "View Salary Structure",
            matches: ["/SalaryStructure"],
          },
          {
            label: "Generate Salary Slip",
            to: "/GenerateSalarySlip",
            icon: { active: gensalslip1, inactive: gensalslip },
            permission: "View Generate Salary Slip",
            matches: ["/GenerateSalarySlip"],
          },
          {
            label: "Salary Muster Roll",
            to: "/SalaryMasterRoll",
            icon: { active: musterrole1, inactive: musterrole },
            permission: "View Salary Muster Roll",
            matches: ["/SalaryMasterRoll"],
          },
          {
            label: "Hourly Salary Muster Roll",
            to: "/HourlySalaryMusterRoll",
            icon: { active: musterrole1, inactive: musterrole },
            permission: "View Hourly Salary Muster Roll",
            matches: ["/HourlySalaryMusterRoll"],
          },
          {
            label: "Salary Structure Wizard",
            to: "/SalaryStructureWizard",
            icon: { active: salarystr1, inactive: salarystr },
            matches: ["/SalaryStructureWizard"],
          },
        ],
      },
      {
        label: "Purchase Order",
        to: "/ErpManagement",
        icon: { active: settings1, inactive: settings },
        matches: ["/ErpManagement"],
      },
      {
        key: "apProcurement-walletAdmin",
        label: "Wallet Admin",
        eventKey: "26-walletAdmin",
        type: "accordion",
        icon: { lucide: "BarChart3" },
        permission: "View Wallet Admin",
        matches: [{ startsWith: "/wallet/admin" }],
        items: [
          {
            label: "Dashboard",
            to: "/wallet/admin/dashboard",
            icon: { lucide: "BarChart3" },
            permission: "View Wallet Admin Dashboard",
            matches: ["/wallet/admin/dashboard"],
          },
          {
            label: "Users",
            to: "/wallet/admin/users",
            icon: { lucide: "UsersIcon" },
            permission: "View Wallet Admin Users",
            matches: ["/wallet/admin/users"],
          },
          {
            label: "Payouts",
            to: "/wallet/admin/payouts",
            icon: { lucide: "CreditCard" },
            permission: "View Wallet Admin Payouts",
            matches: ["/wallet/admin/payouts"],
          },
          {
            label: "Settlements",
            to: "/wallet/admin/settlements",
            icon: { lucide: "FileText" },
            permission: "View Wallet Admin Settlements",
            matches: ["/wallet/admin/settlements"],
          },
          {
            label: "Holds",
            to: "/wallet/admin/holds",
            icon: { lucide: "PauseCircle" },
            permission: "View Wallet Admin Holds",
            matches: ["/wallet/admin/holds"],
          },
        ],
      },
    ],
  },

  // 5. AR Revenue (Sales)
  {
    key: "arRevenue",
    label: "AR Revenue",
    eventKey: "21",
    icon: { active: EmployeeManagementActiveIcon, inactive: EmployeeManagementIcon },
    anyPermission: [
      "View Sales Goods",
      "AR Revenue Sales",
      "View Sales Goods Invoice List",
      "View Sales Purchase Invoice List",
      "View Purchase Goods",
      "View Purchase Service",
      "View Purchase Goods Invoice List",
      "View Purchase Service Invoice List",
      "View Sales Setting",
      "View Wallet",
    ],
    matches: [
      "/SalesGoods",
      "/AddEmployee",
      "/SalesServices",
      "/sales-goods-invoices",
      "/sales-service-invoices",
      "/pristan-management-setting",
      "/paymentreciept",
      "/generateinvoice",
      "/invoicegenerate",
      "/moneyreciept",
      "/EditEmployeeProfile/:id",
    ],
    type: "accordion",
    items: [
      {
        key: "arRevenue-sales",
        label: "Sales",
        eventKey: "21-sales",
        type: "accordion",
        anyPermission: [
          "View Sales Goods",
          "AR Revenue Sales",
          "View Sales Goods Invoice List",
          "View Sales Purchase Invoice List",
        ],
        matches: [
          "/SalesGoods",
          "/SalesServices",
          "/sales-goods-invoices",
          "/sales-service-invoices",
        ],
        items: [
          {
            label: "Goods",
            to: "/SalesGoods",
            permission: "View Sales Goods",
            matches: ["/SalesGoods"],
          },
          {
            label: "Service",
            to: "/SalesServices",
            permission: "View Sales Service",
            matches: ["/SalesServices"],
          },
          {
            label: "Goods Invoice List",
            to: "/sales-goods-invoices",
            permission: "View Sales Goods Invoice List",
            matches: ["/sales-goods-invoices"],
          },
          {
            label: "Service Invoice List",
            to: "/sales-service-invoices",
            permission: "View Sales Purchase Invoice List",
            matches: ["/sales-service-invoices"],
          },
        ],
      },
      {
        label: "Setting",
        to: "/pristan-management-setting",
        icon: { active: slider1, inactive: slider },
        permission: "View Sales Setting",
        matches: [
          "/pristan-management-setting",
          "/paymentreciept",
          "/generateinvoice",
          "/invoicegenerate",
          "/moneyreciept",
        ],
      },
      {
        label: "Advance Receipt",
        to: "/paymentreciept",
        permission: "View Advance Receipt",
        matches: ["/paymentreciept"],
      },
      {
        label: "Create Invoice",
        to: "/generateinvoice",
        permission: "View Create Invoice",
        matches: ["/generateinvoice"],
      },
      {
        label: "Generate Invoice",
        to: "/invoicegenerate",
        permission: "View Generate Invoice",
        matches: ["/invoicegenerate"],
      },
      {
        label: "Money Receipt",
        to: "/moneyreciept",
        permission: "View Money Receipt",
        matches: ["/moneyreciept"],
      },
    ],
  },

  // 6. Compliance
  {
    key: "compliance",
    label: "Compliance",
    eventKey: "10",
    icon: { active: ComplianceActive, inactive: Compliance },
    anyPermission: [
      "View Team Not Assigned",
      "View Project Assigned",
      "View Project De-Assigned",
      "View Timesheet Not Entered",
      "View Project Not Assigned",
      "View Two Plus Project Assigned",
      "View Task Not Added",
      "View Timesheet Not Approved",
      "View Timesheet Period Over",
      "View Bench List",
      "View Compliance Settings",
      "View User Not Login",
      "View User Last Login",
      "View User Activity",
    ],
    matches: [
      "/TeamNotAssigned",
      "/ProjectNotAssigned",
      "/ProjectAssigned",
      "/ProjectDeAssign",
      "/TwoPlusProjectsAssigned",
      "/TaskNotAddedAgainstProject",
      "/TaskNotApproved",
      "/TimesheetNotEntered",
      "/TimesheetNotApproved",
      "/TimePeriodOver",
      "/BenchList",
      "/UsernotLogin",
      "/ComplianceSetting",
      "/UserLastLogin",
      "/UserActivity",
      "/UserNotLogin",
    ],
    type: "accordion",
    items: [
      {
        label: "Bench list",
        to: "/BenchList",
        icon: { active: benchlist1, inactive: benchlist },
        permission: "View Bench List",
        matches: ["/BenchList"],
      },
      {
        label: "Compliance Setting",
        to: "/ComplianceSetting",
        icon: { active: complsett1, inactive: complsett },
        permission: "View Compliance Settings",
        matches: ["/ComplianceSetting"],
      },
      {
        label: "Employee Weekly Hours",
        to: "/WeeklyAttendance",
        icon: { active: reguser1, inactive: reguser },
        permission: "View Employee Weekly Hours",
        matches: ["/WeeklyAttendance"],
      },
      {
        label: "Project Not Assigned",
        to: "/ProjectNotAssigned",
        icon: { active: prjnotassign1, inactive: prjnotassign },
        permission: "View Project Not Assigned",
        matches: ["/ProjectNotAssigned"],
      },
      {
        label: "Project Assigned",
        to: "/ProjectAssigned",
        icon: { active: prjss1, inactive: prjss },
        permission: "View Project Assigned",
        matches: ["/ProjectAssigned"],
      },
      {
        label: "Project De-Assigned",
        to: "/ProjectDeAssign",
        icon: { active: prjdeassign1, inactive: prjdeassign },
        permission: "View Project De-Assigned",
        matches: ["/ProjectDeAssign"],
      },
      {
        label: "Team Not Assigned",
        to: "/TeamNotAssigned",
        icon: { active: teamnotassigned1, inactive: teamnotassigned },
        permission: "View Team Not Assigned",
        matches: ["/TeamNotAssigned"],
      },
      {
        label: "2+ Projects Assigned",
        to: "/TwoPlusProjectsAssigned",
        icon: { active: twoplusprj1, inactive: twoplusprj },
        permission: "View Two Plus Project Assigned",
        matches: ["/TwoPlusProjectsAssigned"],
      },
      {
        label: "Task Not Added",
        to: "/TaskNotAddedAgainstProject",
        icon: { active: tasknotadd1, inactive: tasknotadd },
        permission: "View Task Not Added",
        matches: ["/TaskNotAddedAgainstProject"],
      },
      {
        label: "Task Not Approved",
        to: "/TaskNotApproved",
        icon: { active: tasknotapp1, inactive: tasknotapp },
        permission: "View Task Not Approved",
        matches: ["/TaskNotApproved"],
      },
      {
        label: "Timesheet Not Entered",
        to: "/TimesheetNotEntered",
        permission: "View Timesheet Not Entered",
        matches: ["/TimesheetNotEntered"],
      },
      {
        label: "Timesheet Not Approved",
        to: "/TimesheetNotApproved",
        permission: "View Timesheet Not Approved",
        matches: ["/TimesheetNotApproved"],
      },
      {
        label: "Timesheet Period Over",
        to: "/TimePeriodOver",
        icon: { active: timesheerperover1, inactive: timesheerperover },
        permission: "View Timesheet Period Over",
        matches: ["/TimePeriodOver"],
      },
      {
        label: "User Not Login",
        to: "/UserNotLogin",
        icon: { active: usernotlogin1, inactive: usernotlogin },
        permission: "View User Not Login",
        matches: ["/UserNotLogin"],
      },
      {
        label: "User Last Login",
        to: "/UserLastLogin",
        icon: { active: userlastlogin1, inactive: userlastlogin },
        permission: "View User Last Login",
        matches: ["/UserLastLogin"],
      },
      {
        label: "User Activity",
        to: "/UserActivity",
        icon: { active: reguser1, inactive: reguser },
        permission: "View User Activity",
        matches: ["/UserActivity"],
      },
    ],
  },

  // 7. AI Assistant Admin (Chat Admin / Bot)
  {
    key: "aiAssistantAdmin",
    label: "AI Assistant Admin",
    eventKey: "16",
    icon: { active: Bot, inactive: Bot },
    anyPermission: [
      "Un-Answered List",
      "Question List",
      "Add Question",
      "ChatBot Setting",
      "Import Training Questions",
      "Conversation Flow",
      "ChatBot Conversation",
    ],
    matches: [
      "/accesscode",
      "/unAnsweredListing",
      "/questionListing",
      "/addQuestion",
      "/setting",
      "/traineeQues",
      "/converstionflow",
      "/adminChat",
    ],
    type: "accordion",
    items: [
      {
        label: "Add Question",
        to: "/addQuestion",
        icon: { active: addQue, inactive: addQue1 },
        permission: "Add Question",
        matches: ["/addQuestion"],
      },
      {
        label: "Conversations",
        to: "/adminChat",
        icon: { active: coversations, inactive: coversations1 },
        permission: "ChatBot Conversation",
        matches: ["/adminChat"],
      },
      {
        label: "Conversation Flow",
        to: "/converstionflow",
        icon: { active: convFlow, inactive: convFlow1 },
        permission: "Conversation Flow",
        matches: ["/converstionflow"],
      },
      {
        label: "Import Training Questions",
        to: "/traineeQues",
        icon: { active: traineeQue, inactive: traineeQue1 },
        permission: "Import Training Questions",
        matches: ["/traineeQues"],
      },
      {
        label: "Question List",
        to: "/questionListing",
        icon: { active: queList, inactive: queList1 },
        permission: "Question List",
        matches: ["/questionListing"],
      },
      {
        label: "Setting",
        to: "/setting",
        icon: { active: setting, inactive: setting1 },
        permission: "ChatBot Setting",
        matches: ["/setting", "/accesscode"],
        items: [
          {
            label: "Access",
            to: "/accesscode",
            icon: { active: accesscode, inactive: accesscode1 },
            matches: ["/accesscode"],
          },
        ],
      },
      {
        label: "Un-Answered List",
        to: "/unAnsweredListing",
        icon: { active: unAns, inactive: unAns1 },
        permission: "Un-Answered List",
        matches: ["/unAnsweredListing"],
      },
    ],
  },

  // 8. CRM Office Caller
  {
    key: "crmOfficeCaller",
    label: "CRM",
    eventKey: "15",
    icon: { active: CRMOfficeCaller_active, inactive: CRMphone_iactive },
    permission: "View CRM Office Caller",
    matches: [
      "/LeadManagement",
      "/InvalidLeads",
      "/EmailReport",
      "/Campaign",
      "/Admin",
      "/QueryCases",
      "/CrmPushNotification",
      "/GoogleAnalytics",
      "/CrmWebsite",
      "/CrmSendgrid",
      "/CategoriesOfficeCaller",
      "/CrmApp",
      "/BulkUpload",
      "/Domains",
      "/NonFunctionalFeatures",
      "/ContactCustomGroup",
      "/DefaultGroup",
      "/LeadListCount",
      "/quotation",
      "/quotationStatus",
      "/statsticsreports",
      "/WelletPage",
    ],
    type: "accordion",
    items: [
      {
        label: "Admin",
        to: "/Admin",
        icon: { active: admin1, inactive: admin },
        matches: ["/Admin"],
        socketTrigger: "getCallHistory",
      },
      {
        label: "Campaign",
        to: "/Campaign",
        icon: { active: campaign1, inactive: campaign },
        matches: ["/Campaign"],
        socketTrigger: "getCallHistory",
      },
      {
        key: "crm-contactGroup",
        label: "Contact Group Management",
        type: "accordion",
        icon: { active: contactgrpmgt1, inactive: contactgrpmgt },
        matches: ["/ContactCustomGroup", "/DefaultGroup"],
        items: [
          {
            label: "Contact Custom Group",
            to: "/ContactCustomGroup",
            icon: { active: contactcusgrp1, inactive: contactcusgrp },
            matches: ["/ContactCustomGroup"],
          },
          {
            key: "crm-domains",
            label: "Domains And Apps",
            type: "accordion",
            icon: { active: domapp1, inactive: domapp },
            matches: [
              "/CategoriesOfficeCaller",
              "/CrmApp",
              "/BulkUpload",
              "/Domains",
              "/NonFunctionalFeatures",
            ],
            items: [
              {
                label: "Domains",
                to: "/Domains",
                icon: { active: domain1, inactive: domain },
                matches: ["/Domains"],
              },
              {
                label: "Categories",
                to: "/CategoriesOfficeCaller",
                icon: { active: categories1, inactive: categories },
                matches: ["/CategoriesOfficeCaller"],
              },
              {
                label: "Apps",
                to: "/CrmApp",
                icon: { active: apps1, inactive: apps },
                matches: ["/CrmApp"],
              },
              {
                label: "Non-Functional Features",
                to: "/NonFunctionalFeatures",
                icon: { active: nonfuncfea1, inactive: nonfuncfea },
                matches: ["/NonFunctionalFeatures"],
              },
              {
                label: "Bulk contact upload",
                to: "/BulkUpload",
                icon: { active: bulkupload1, inactive: bulkupload },
                matches: ["/BulkUpload"],
              },
            ],
          },
          {
            label: "Default Groups",
            to: "/DefaultGroup",
            icon: { active: defgrp1, inactive: defgrp },
            matches: ["/DefaultGroup"],
          },
        ],
      },
      {
        key: "crm-leadManagement",
        label: "Lead Management",
        type: "accordion",
        icon: { active: leadmgt1, inactive: leadmgt },
        matches: ["/LeadManagement", "/InvalidLeads", "/EmailReport", "/LeadListCount"],
        items: [
          {
            label: "Leads",
            to: "/LeadManagement",
            icon: { active: leads1, inactive: leads },
            matches: ["/LeadManagement"],
          },
          {
            label: "Invalid Leads",
            to: "/InvalidLeads",
            icon: { active: invalidleads1, inactive: invalidleads },
            matches: ["/InvalidLeads"],
          },
          {
            label: "Email Report",
            to: "/EmailReport",
            icon: { active: emailrep1, inactive: emailrep },
            matches: ["/EmailReport"],
          },
        ],
      },
      {
        label: "Query Management",
        to: "/QueryCases",
        icon: { active: querymgt1, inactive: querymgt },
        matches: ["/QueryCases"],
        socketTrigger: "getCallHistory",
      },
      {
        key: "crm-settings",
        label: "Settings",
        type: "accordion",
        matches: [
          "/CrmPushNotification",
          "/GoogleAnalytics",
          "/CrmWebsite",
          "/CrmSendgrid",
        ],
        items: [
          {
            label: "Push Notification",
            to: "/CrmPushNotification",
            icon: { active: pushnoti1, inactive: pushnoti },
            matches: ["/CrmPushNotification"],
          },
          {
            label: "Google Analytics",
            to: "/GoogleAnalytics",
            icon: { active: googleana1, inactive: googleana },
            matches: ["/GoogleAnalytics"],
          },
          {
            label: "Website",
            to: "/CrmWebsite",
            icon: { active: website1, inactive: website },
            matches: ["/CrmWebsite"],
          },
          {
            label: "Sendgrid",
            to: "/CrmSendgrid",
            icon: { active: sendgrid, inactive: sendgrid },
            matches: ["/CrmSendgrid"],
          },
        ],
      },
      {
        key: "crm-quotation",
        label: "Quotation",
        eventKey: "19",
        type: "accordion",
        icon: { active: filetextt1, inactive: filetextt },
        matches: [
          "/createquote",
          "/quotation",
          "/quotationStatus",
          "/updatequote",
          "/statsticsreports",
        ],
        items: [
          {
            label: "View/List Quote",
            to: "/quotation",
            permission: "View Create Quote",
            matches: ["/quotation"],
          },
          {
            label: "Quote Details / Audit Trial",
            to: "/quotationStatus",
            matches: ["/quotationStatus"],
          },
          {
            label: "Statistics and Report",
            to: "/statsticsreports",
            matches: ["/statsticsreports"],
          },
        ],
      },
    ],
  },

  // 9. CRM Phonebook
  {
    key: "crmPhonebook",
    label: "CRM Phonebook",
    eventKey: "3",
    icon: { active: CRMOfficeCaller_active, inactive: CRMphone_iactive },
    anyPermission: [
      "View Agent",
      "View Call",
      "View Not Call Classification",
      "View Users",
      "View Agent Call Summary",
      "View Candidate Raw Data",
      "View Frequent Caller",
      "View Zero Call List",
      "View Service Request",
      "View Consultant",
      "View Supplier",
    ],
    matches: [
      "/AgentList",
      "/CRMCalls",
      "/Users",
      "/WhatsappSetting",
      "/NotCallClassification",
      "/ZeroCallList",
      "/FrequentCaller",
      "/ServiceRequest",
      "/AgentCallSummary",
      "/AssignCallUsers",
      "/SalesInternationalcall",
      "/UploadCandidateOld",
      "/Supplier",
      "/Consultant",
      "/WhatsappPromotion",
      "/CandidatesData",
      "/DownloadAgentReport",
      "/BulkCallView",
      "/CallReport",
      "/bulkuploadofficecaller",
    ],
    type: "accordion",
    items: [
      {
        label: "Agent",
        to: "/AgentList",
        icon: { active: agent1, inactive: agent },
        permission: "View Agent",
        matches: ["/AgentList"],
        socketTrigger: "getPrivateChat",
      },
      {
        label: "Agent Call Summary",
        to: "/AgentCallSummary",
        icon: { active: agentcallsumm1, inactive: agentcallsumm },
        permission: "View Agent Call Summary",
        matches: ["/AgentCallSummary"],
        socketTrigger: "getPrivateChat",
      },
      {
        label: "Bulk contact upload",
        to: "/bulkuploadofficecaller",
        icon: { active: bulkupload1, inactive: bulkupload },
        permission: "View Bulk Contact Upload",
        matches: ["/bulkuploadofficecaller"],
      },
      {
        label: "Calls",
        to: "/CRMCalls",
        icon: { active: calls1, inactive: calls },
        permission: "View Call",
        matches: ["/CRMCalls"],
        socketTrigger: "getProjects",
      },
      {
        label: "Consultant",
        to: "/Consultant",
        icon: { active: consultant1, inactive: consultant },
        permission: "View Consultant",
        matches: ["/Consultant"],
      },
      {
        label: "Candidate Raw Data",
        to: "/UploadCandidateOld",
        icon: { active: rawdata1, inactive: rawdata },
        permission: "View Candidate Raw Data",
        matches: ["/UploadCandidateOld"],
      },
      {
        key: "crmPhonebook-candidate",
        label: "Candidate (Process Data)",
        type: "accordion",
        icon: { active: candi1, inactive: candi },
        anyPermission: [
          "View Candidates Data",
          "View Re-sign Candidate",
          "View Call Report",
        ],
        matches: [
          "/CandidatesData",
          "/DownloadAgentReport",
          "/BulkCallView",
          "/UpdateUserDetails",
          "/AssignCallUsers",
          "/CallReport",
        ],
        items: [
          {
            label: "Call Assigning",
            to: "/AssignCallUsers",
            icon: { active: callassign1, inactive: callassign },
            matches: ["/AssignCallUsers"],
          },
          {
            label: "Download Data",
            to: "/DownloadAgentReport",
            icon: { active: download1, inactive: download },
            matches: ["/DownloadAgentReport"],
          },
          {
            label: "Re-Sign Candidate",
            to: "/BulkCallView",
            icon: { active: reassign1, inactive: reassign },
            permission: "View Re-sign Candidate",
            matches: ["/BulkCallView"],
          },
          {
            label: "View Data",
            to: "/CandidatesData",
            icon: { active: viewdata1, inactive: viewdata },
            permission: "View Candidates Data",
            matches: ["/CandidatesData"],
          },
        ],
      },
      {
        label: "Frequent Caller",
        to: "/FrequentCaller",
        icon: { active: freqcall1, inactive: freqcall },
        permission: "View Frequent Caller",
        matches: ["/FrequentCaller"],
      },
      {
        label: "Not Call Classification",
        to: "/NotCallClassification",
        icon: { active: notcall1, inactive: notcall },
        permission: "View Not Call Classification",
        matches: ["/NotCallClassification"],
      },
      {
        label: "Supplier",
        to: "/Supplier",
        icon: { active: supplier1, inactive: supplier },
        permission: "View Supplier",
        matches: ["/Supplier"],
      },
      {
        label: "Service Request",
        to: "/ServiceRequest",
        icon: { active: servicereq1, inactive: servicereq },
        permission: "View Service Request",
        matches: ["/ServiceRequest"],
      },
      {
        label: "Sales International call",
        to: "/SalesInternationalcall",
        icon: { active: salesinter1, inactive: salesinter },
        matches: ["/SalesInternationalcall"],
      },
      {
        label: "Users",
        to: "/Users",
        icon: { active: users1, inactive: users },
        permission: "View Users",
        matches: ["/Users"],
        socketTrigger: "getTeams",
      },
      {
        label: "WhatsappPromotion",
        to: "/WhatsappPromotion",
        icon: { active: whtsapppromo1, inactive: whtsapppromo },
        matches: ["/WhatsappPromotion"],
      },
      {
        label: "Zero Call List",
        to: "/ZeroCallList",
        icon: { active: zerocall1, inactive: zerocall },
        permission: "View Zero Call List",
        matches: ["/ZeroCallList"],
      },
    ],
  },

  // 10. Client Management
  {
    key: "clientManagement",
    label: "Client Management",
    eventKey: "5",
    icon: { active: ClientManActive, inactive: ClientMan },
    anyPermission: ["View Client List", "View Members"],
    matches: [
      "/ClientManagement",
      "/clientlist",
      "/servicemapping",
      "/subscriptionlist",
      "/feedback",
      "/Members",
      "/clientDetails",
      "/Memberlist",
    ],
    type: "accordion",
    items: [
      {
        label: "Client",
        to: "/clientlist",
        icon: { active: clientmgt1, inactive: clientmgt },
        permission: "View Client List",
        matches: ["/clientlist", "/Members"],
      },
      {
        label: "Manage Members",
        to: "/Memberlist",
        icon: { active: clientmgt1, inactive: clientmgt },
        permission: "View Members",
        matches: ["/Memberlist"],
      },
      {
        label: "Holidays And Events",
        to: "/holidaysandevents",
        permission: "Holiday And Events",
        matches: ["/holidaysandevents"],
      },
      {
        label: "Terms & Conditions",
        to: "/TearmsAmdCondiation",
        permission: "Terms & Conditions",
        matches: ["/TearmsAmdCondiation"],
      },
      {
        label: "Privacy Policy",
        to: "/PrivacyPolicy",
        permission: "Privacy Policy",
        matches: ["/PrivacyPolicy"],
      },
      {
        label: "About Organization",
        to: "/AboutOrganziation",
        permission: "View Organization",
        matches: ["/AboutOrganziation"],
      },
    ],
  },

  // 11. Employee Management
  {
    key: "employeeManagement",
    label: "Employee Management",
    eventKey: "13",
    icon: { active: EmployeeManagementActiveIcon, inactive: EmployeeManagementIcon },
    anyPermission: ["Create Employee", "View Employee List"],
    matches: ["/List", "/AddEmployee", "/EditEmployeeProfile/:id"],
    type: "accordion",
    items: [
      {
        label: "Employee List",
        to: "/List",
        icon: { active: emplist1, inactive: emplist },
        permission: "View Employee List",
        matches: ["/List"],
      },
      {
        label: "Add Employee",
        to: "/AddEmployee",
        icon: { active: addemp1, inactive: addemp },
        permission: "View Add Employee",
        matches: ["/AddEmployee"],
      },
      {
        label: "Employee Document",
        to: "/employeedoucemnt",
        icon: { active: empDoc1, inactive: empDoc },
        permission: "View Employee Documents",
        matches: ["/employeedoucemnt"],
      },
    ],
  },

  // 12. Financial Reporting & GL (Account Reports / Profit & Loss)
  {
    key: "financialReportingGL",
    label: "Financial Reporting & GL",
    eventKey: "218",
    icon: { active: chartaxess1, inactive: chartaxess },
    anyPermission: [
      "View Account Report",
      "View Profit & Loss",
      "View Balance Sheet",
      "View Cash Flows",
      "View Trial Balance",
      "View Manual Ledger Form",
      "View Ledger Group",
      "View Ledger Master",
      "View Manage Ledgers",
      "View Primary Ledger Group",
    ],
    matches: ["/AccountServiceReport", "/financialStatement", "/ledger", "/settlement-report"],
    type: "accordion",
    items: [
      {
        label: "Financial Statement",
        to: "/financialStatement",
        permission: "View Financial Statement",
        matches: ["/financialStatement"],
      },
      {
        label: "Ledger",
        to: "/ledger",
        anyPermission: [
          "View Ledger Group",
          "View Ledger Master",
          "View Manage Ledgers",
          "View Primary Ledger Group",
        ],
        matches: ["/ledger"],
      },
      {
        label: "Settlement Report",
        to: "/settlement-report",
        permission: "View Settlement Report",
        matches: ["/settlement-report"],
      },
    ],
  },

  // 13. HR Admin (Hr Management)
  {
    key: "hrManagement",
    label: "Hr Management",
    eventKey: "55",
    icon: { active: EmployeeManagementActiveIcon, inactive: EmployeeManagementIcon },
    permission: "View Hr Admin",
    matches: ["/hrAdmin"],
    type: "accordion",
    items: [
      {
        label: "Recruitment",
        to: "/hrAdmin",
        icon: { active: dashboard_icon_active, inactive: dashboard_icon },
        matches: ["/hrAdmin"],
      },
    ],
  },

  // 14. Inventory Management
  {
    key: "inventoryManagement",
    label: "Inventory Management",
    eventKey: "23",
    icon: { active: inventactive, inactive: invent },
    anyPermission: [
      "View Inventory Management",
      "View Menu List",
      "View Stock",
      "View Menu Item On/Off",
      "View Order Listing",
      "View Store Management",
    ],
    matches: [
      "/BaseMenu",
      "/MenuOnOff",
      "/Onlineorderactivity",
      "/ManageStore",
      "/Stock",
      "/StoreManage",
      "/StoreConfig",
    ],
    type: "accordion",
    items: [
      {
        label: "Kitchen Management",
        to: "/StoreManage",
        icon: { active: stockactive, inactive: stock },
        permission: "View Kitchen Management",
        matches: ["/StoreManage"],
      },
      {
        label: "Menu List",
        to: "/BaseMenu",
        icon: { active: menulist, inactive: menulistactive },
        permission: "View Menu List",
        matches: ["/BaseMenu"],
      },
      {
        label: "Menu Item On/Off",
        to: "/MenuOnOff",
        icon: { active: addemp1, inactive: addemp },
        permission: "View Menu Item On/Off",
        matches: ["/MenuOnOff"],
      },
      {
        label: "Order Listing",
        to: "/Onlineorderactivity",
        icon: { active: orderlistactive, inactive: orderlist },
        permission: "View Order Listing",
        matches: ["/Onlineorderactivity"],
      },
      {
        label: "Store Management",
        to: "/ManageStore",
        icon: { active: storemgtactive, inactive: storemgt },
        permission: "View Store Management",
        matches: ["/ManageStore"],
      },
      {
        label: "Stock",
        to: "/Stock",
        icon: { active: stockactive, inactive: stock },
        permission: "View Stock",
        matches: ["/Stock"],
      },
      {
        label: "Store Setting",
        to: "/StoreConfig",
        icon: { active: stockactive, inactive: stock },
        permission: "View Stock",
        matches: ["/StoreConfig"],
      },
    ],
  },

  // 15. Organization Setting
  {
    key: "organizationSetting",
    label: "Organization Setting",
    eventKey: "9",
    icon: { active: Organ_Dark, inactive: Organ_active },
    anyPermission: [
      "Team Chart",
      "View Financial Year",
      "View Shift Masters",
      "View Calendar Settings",
      "View Organization Details",
      "SMS Gateway",
      "View WhatsApp Settings",
      "About Organization",
      "Privacy Policy",
      "Holiday And Events",
      "Terms & Conditions",
      "Payment Gateway",
      "View Holiday",
      "View IVR Settings",
      "View Employee Code",
      "View All Announcement",
      "View Service Group",
      "View Service",
      "View Rate Table",
      "View Module",
      "View Sub Module",
      "View Permission",
    ],
    matches: [
      "/teamchart",
      "/AllAnnouncement",
      "/MyAnnouncement",
      "/holidaysandevents",
      "/TearmsAmdCondiation",
      "/PrivacyPolicy",
      "/AboutOrganziation",
      "/Holidays",
      "/Academic",
      "/CalendarSettings",
      "/ShiftMaster",
      "/OrgainsationInfo",
      "/OrgDetails",
      "/ManageDept",
      "/ManageDesig",
      "/ManageLoc",
      "/SMSgateway",
      "/PaymentGateway",
      "/ivrsetting",
      "/whatsappsetting",
      "/serviceManagement",
      "/service",
      "/ratetable",
      "/permissionmanagement",
      "/Role",
      "/AddonSettings",
      "/EmployeeCode",
      "/Ivrgetewway",
      "/GeneralSetting",
      { startsWith: "/wallet/admin/" },
    ],
    type: "accordion",
    items: [
      {
        label: "Access Control",
        to: "/Role",
        icon: { active: role1, inactive: role },
        permission: "View Access Control",
        matches: ["/Role", "/AssignRole", "/Permission"],
      },
      {
        label: "Organization Chart",
        to: "/teamchart",
        icon: { active: Organ_Dark, inactive: Organ_active },
        permission: "View Organization Chart",
        matches: ["/teamchart"],
      },
      {
        label: "Addon Setting",
        to: "/AddonSettings",
        icon: { active: settings1, inactive: settings },
        permission: "View Addon Setting",
        matches: ["/AddonSettings"],
      },
      {
        label: "Employee Code Setting",
        to: "/EmployeeCode",
        icon: { active: empcode1, inactive: empcode },
        permission: "View Employee Code",
        matches: ["/EmployeeCode"],
      },
      {
        label: "Financial Year",
        to: "/Academic",
        icon: { active: finyear1, inactive: finyear },
        permission: "View Financial Year",
        matches: ["/Academic"],
      },
      {
        label: "Holidays",
        to: "/Holidays",
        icon: { active: holidays1, inactive: holidays },
        permission: "View Holiday",
        matches: ["/Holidays"],
      },
      {
        label: "IVR Service",
        to: "/Ivrgetewway",
        icon: { active: smspromo1, inactive: smspromo },
        permission: "IVR Service",
        matches: ["/Ivrgetewway"],
      },
      {
        label: "Organization Info",
        to: "/OrgainsationInfo",
        icon: { active: orginfo1, inactive: orginfo },
        permission: "View Organization Details",
        matches: [
          "/OrgainsationInfo",
          "/OrgDetails",
          "/ManageDesig",
          "/ManageLoc",
          "/ManageDept",
        ],
      },
      {
        label: "Manage Permission",
        to: "/permissionmanagement",
        anyPermission: ["View Module", "View Sub Module", "View Permission"],
        matches: ["/permissionmanagement"],
      },
      {
        label: "Payment Gateway",
        to: "/PaymentGateway",
        icon: { active: paymentgat1, inactive: paymentgat },
        permission: "Payment Gateway",
        matches: ["/PaymentGateway"],
      },
      {
        label: "Holidays And Events",
        to: "/holidaysandevents",
        permission: "Holiday And Events",
        matches: ["/holidaysandevents"],
      },
      {
        label: "Terms & Conditions",
        to: "/TearmsAmdCondiation",
        permission: "Terms & Conditions",
        matches: ["/TearmsAmdCondiation"],
      },
      {
        label: "Privacy Policy",
        to: "/PrivacyPolicy",
        permission: "Privacy Policy",
        matches: ["/PrivacyPolicy"],
      },
      {
        label: "About Organization",
        to: "/AboutOrganziation",
        permission: "About Organization",
        matches: ["/AboutOrganziation"],
      },
      {
        label: "Shift Master",
        to: "/ShiftMaster",
        icon: { active: shiftmas1, inactive: shiftmas },
        permission: "View Shift Masters",
        matches: ["/ShiftMaster"],
      },
      {
        label: "SMS Gateway",
        to: "/SMSgateway",
        icon: { active: smspromo1, inactive: smspromo },
        permission: "SMS Gateway",
        matches: ["/SMSgateway"],
      },
      {
        label: "IVR Setting",
        to: "/ivrsetting",
        icon: { active: ivrsett1, inactive: ivrsett },
        permission: "View IVR Settings",
        matches: ["/ivrsetting"],
      },
      {
        key: "org-serviceManagement",
        label: "Service Management",
        type: "accordion",
        icon: { active: domapp1, inactive: domapp },
        anyPermission: ["View Service Group", "View Service", "View Rate Table"],
        matches: ["/serviceManagement", "/service", "/ratetable"],
        items: [
          {
            label: "Service Group",
            to: "/serviceManagement",
            permission: "View Service Group",
            matches: ["/serviceManagement"],
          },
          {
            label: "Service",
            to: "/service",
            permission: "View Service",
            matches: ["/service"],
          },
          {
            label: "Rate Table",
            to: "/ratetable",
            permission: "View Rate Table",
            matches: ["/ratetable"],
          },
        ],
      },
      {
        label: "Settings",
        to: "/GeneralSetting",
        icon: { active: settings1, inactive: settings },
        permission: "View Settings",
        matches: ["/GeneralSetting"],
      },
      {
        label: "AI Settings &  Configuration",
        to: "/Ai-setting",
        icon: { active: settings1, inactive: settings },
        permission: "View Settings",
        matches: ["/Ai-setting"],
      },
      {
        label: "WhatsApp Setting",
        to: "/whatsappsetting",
        icon: { active: whtsappsett11, inactive: whtsappsettt },
        permission: "View WhatsApp Settings",
        matches: ["/whatsappsetting"],
      },
      {
        key: "org-wallet",
        label: "Wallet",
        type: "accordion",
        matches: [{ startsWith: "/wallet/admin/" }],
        items: [
          {
            label: "API Keys",
            to: "/wallet/admin/api-keys",
            matches: ["/wallet/admin/api-keys"],
          },
          {
            label: "Wallet Limits",
            to: "/wallet/admin/limits",
            matches: ["/wallet/admin/limits"],
          },
          {
            label: "Reward Credit",
            to: "/wallet/admin/rewards",
            matches: ["/wallet/admin/rewards"],
          },
        ],
      },
    ],
  },

  // 17. Point Of Sales (Employee Wallet / View Wallet)
  {
    key: "pointOfSales",
    label: "Point Of Sales",
    icon: { active: walletActive, inactive: wallet },
    permission: "View Wallet",
    matches: [
      "/EmpoloyeeWallet",
      "/RechargeWallet",
      "/WalletSales",
      "/TransactionReceipt",
      "/WalletRecharge",
      "/Store",
      "/Categories",
      "/Product",
      "/CreateCategories",
      "/CreateProducts",
      "/ProductStock",
      "/AddProductStock",
      "/IssueCard",
    ],
    type: "accordion",
    items: [
      {
        label: "Categories",
        to: "/Categories",
        matches: ["/Categories", "/CreateCategories"],
      },
      {
        label: "Employee Wallet",
        to: "/EmpoloyeeWallet",
        matches: ["/EmpoloyeeWallet", "/RechargeWallet"],
      },
      {
        label: "Issue Card",
        to: "/IssueCard",
        matches: ["/IssueCard"],
      },
      {
        label: "Products",
        to: "/Product",
        matches: ["/Product", "/CreateProducts"],
      },
      {
        label: "Products Stock",
        to: "/ProductStock",
        matches: ["/ProductStock", "/AddProductStock"],
      },
      {
        label: "Store",
        to: "/Store",
        matches: ["/Store"],
      },
      {
        label: "Wallet Sales",
        to: "/WalletSales",
        matches: ["/WalletSales", "/TransactionReceipt"],
      },
      {
        label: "Wallet Recharges",
        to: "/WalletRecharge",
        matches: ["/WalletRecharge", "/TransactionReceipt"],
      },
    ],
  },

  // 18. Project Management
  {
    key: "projectManagement",
    label: "Project Management",
    eventKey: "8",
    icon: { active: ProjectMan_Dark, inactive: ProjectMan_active },
    anyPermission: [
      "View Project Documents",
      "View Project Resources",
      "View Project Issues",
      "View Project Allocation",
      "View Project Timesheet Details",
      "View Employee Timesheet Detail",
      "View Project",
      "View Project Schedule",
    ],
    matches: [
      "/projectdocumentation",
      "/projectdetails",
      "/ProjectSchedule",
      "/projectresources",
      "/Project",
      "/ProjectAssignment",
      "/ProjectTimesheetDetails",
      "/ProjectCost",
      "/ProjectCostReport",
    ],
    type: "accordion",
    items: [
      {
        label: "Employee Timesheet Details",
        to: "/EmployeeTimesheetDetails",
        icon: { active: emptimesheetdet1, inactive: emptimesheetdet },
        permission: "View Employee Timesheet Detail",
        matches: ["/EmployeeTimesheetDetails"],
      },
      {
        label: "Project Documents",
        to: "/projectdocumentation",
        icon: { active: prjdoc1, inactive: prjdoc },
        permission: "View Project Documents",
        matches: ["/projectdocumentation", "/projectdetails"],
      },
      {
        label: "Project Schedule",
        to: "/ProjectSchedule",
        icon: { active: prjschedule1, inactive: prjschedule },
        permission: "View Project Schedule",
        matches: ["/ProjectSchedule"],
      },
      {
        label: "Project Resources",
        to: "/projectresources",
        icon: { active: prjres1, inactive: prjres },
        permission: "View Project Resources",
        matches: ["/projectresources"],
      },
      {
        label: "Project Issues",
        to: "#",
        icon: { active: prjissues1, inactive: prjissues },
        permission: "View Project Issues",
        matches: [],
      },
      {
        label: "Projects",
        to: "/Project",
        icon: { active: prj1, inactive: prj },
        permission: "View Project",
        matches: ["/Project"],
      },
      {
        label: "Project Allocation",
        to: "/ProjectAssignment",
        icon: { active: prjAlloc1, inactive: prjAlloc },
        permission: "View Project Allocation",
        matches: ["/ProjectAssignment"],
      },
      {
        label: "Project Timesheet Details",
        to: "/ProjectTimesheetDetails",
        icon: { active: prjtimesheet, inactive: prjtimesheet1 },
        permission: "View Project Timesheet Details",
        matches: ["/ProjectTimesheetDetails"],
      },
      // 19. Project Costing (rendered inline inside Project Management)
      {
        label: "Project Cost",
        to: "/ProjectCost",
        matches: ["/ProjectCost"],
      },
      {
        label: "Project Cost Report",
        to: "/ProjectCostReport",
        icon: { active: prjcostRep1, inactive: prjcostRep },
        permission: "View Project Cost Report",
        matches: ["/ProjectCostReport"],
      },
    ],
  },

  // 21. Reports (CRM Dashboard / Zamzam reports)
  {
    key: "reports",
    label: "Reports",
    eventKey: "233",
    icon: { active: null, inactive: null },
    anyPermission: [],
    matches: [
      "/zamzam-sales-report",
      "/zamzam-day-wise-report",
      "/printList",
      "/reports",
    ],
    type: "link",
    to: "/reports",
  },

  // 22. Subscription Management
  {
    key: "subscriptionManagement",
    label: "Subscription Management",
    eventKey: "20",
    permission: "Subscription list",
    matches: ["/SubscriptionMgt"],
    type: "accordion",
    items: [
      {
        label: "Subscription List",
        to: "/SubscriptionMgt",
        icon: { active: settings1, inactive: settings },
        permission: "Subscription list",
        matches: ["/SubscriptionMgt"],
      },
    ],
  },

  // 23. Task Management
  {
    key: "taskManagement",
    label: "Task Management",
    eventKey: "6",
    icon: { active: taskmanag_icon_active, inactive: taskmanag_icon },
    anyPermission: [
      "View Task",
      "View Task List",
      "View Task Allocation",
      "View Abort Task",
      "View Hold Task",
      "View Complete Task",
      "View Team Task",
      "View roject Task",
      "View Task Approve",
      "View Standard Task",
      "View Task Planner",
      "View Project Task",
    ],
    matches: [
      "/tasklist",
      "/teamtask",
      "/projecttask",
      "/TaskApprove",
      "/AbortTask",
      "/CompleteTask",
      "/StandardTask",
      "/taskDetails",
      "/HoldTask",
      "/Task",
      "/TaskAllocation",
      "/achivements",
      "/TaskPlanner",
      "/task",
      "/dynamicComplteTask/1484/10177",
    ],
    type: "accordion",
    items: [
      {
        label: "Abort Task",
        to: "/AbortTask",
        icon: { active: aborttask1, inactive: aborttask },
        permission: "View Abort Task",
        matches: ["/AbortTask"],
      },
      {
        label: "Employee Task Details",
        to: "/taskDetails",
        icon: { active: emppresentlist1, inactive: emppresentlist },
        permission: "View Standard Task",
        matches: ["/taskDetails"],
      },
      {
        label: "Hold Task",
        to: "/HoldTask",
        icon: { active: holdtask1, inactive: holdtask },
        permission: "View Hold Task",
        matches: ["/HoldTask"],
      },
      {
        label: "Inprogress Task",
        to: "/CompleteTask",
        icon: { active: completetask1, inactive: completetask },
        permission: "View Complete Task",
        matches: ["/CompleteTask"],
      },
      {
        label: "My Achievements",
        to: "/achivements",
        permission: "View Complete Task",
        matches: ["/achivements"],
      },
      {
        label: "Project Task",
        to: "/projecttask",
        icon: { active: prjtask1, inactive: prjtask },
        permission: "View Project Task",
        matches: ["/projecttask"],
      },
      {
        label: "Standard Task",
        to: "/StandardTask",
        icon: { active: stdtask1, inactive: stdtask },
        permission: "View Standard Task",
        matches: ["/StandardTask"],
      },
      {
        label: "Task List",
        to: "/tasklist",
        icon: { active: tasklist1, inactive: tasklist },
        permission: "View Task List",
        matches: ["/tasklist"],
      },
      {
        label: "Task Allocation",
        to: "/TaskAllocation",
        icon: { active: taskalloc1, inactive: taskalloc },
        permission: "View Task Allocation",
        matches: ["/TaskAllocation"],
      },
      {
        label: "Task Planner",
        to: "/TaskPlanner",
        icon: { active: holdtask1, inactive: holdtask },
        permission: "View Task Planner",
        matches: ["/TaskPlanner"],
      },
      {
        label: "Team Task",
        to: "/teamtask",
        icon: { active: teamtask1, inactive: teamtask },
        permission: "View Team Task",
        matches: ["/teamtask"],
      },
      {
        label: "Task Approval",
        to: "/TaskApprove",
        icon: { active: apprvtask1, inactive: apprvtask },
        permission: "View Task Approve",
        matches: ["/TaskApprove"],
      },
      {
        label: "Un-Assigned Task",
        to: "/task",
        icon: { active: task1, inactive: task },
        permission: "View Un Assigned Task",
        matches: ["/task"],
      },
      {
        label: "WorkFlow Task Form",
        icon: { active: emppresentlist1, inactive: emppresentlist },
        permission: "View Workflow Task Form",
        matches: [{ startsWith: "/dynamicComplteTask/" }],
        handler: "workFlowTask",
        badge: "pendingWorkflowTaskCount",
      },
    ],
  },

  // 24. Timesheet Management
  {
    key: "timesheetManagement",
    label: "Timesheet Management",
    eventKey: "7",
    icon: { active: timesheet_icon_active, inactive: timesheet_icon },
    anyPermission: [
      "View Timesheet Entry",
      "View Timesheet History",
      "View Timesheet Approve",
    ],
    matches: ["/timesheet", "/timesheethistory", "/TimesheetApproval"],
    type: "accordion",
    items: [
      {
        label: "Employee Timesheet Details",
        to: "/EmployeeTimesheetDetails",
        icon: { active: emptimedet1, inactive: emptimedet },
        permission: "View Employee Timesheet Details",
        matches: ["/EmployeeTimesheetDetails"],
      },
      {
        label: "Timesheet Entry",
        to: "/timesheet",
        icon: { active: timesheetentry, inactive: timesheetentry1 },
        permission: "View Timesheet Entry",
        matches: ["/timesheet"],
      },
      {
        label: "Timesheet History",
        to: "/timesheethistory",
        icon: { active: timesheethis1, inactive: timesheethis },
        permission: "View Timesheet History",
        matches: ["/timesheethistory"],
      },
      {
        label: "Timesheet Approval",
        to: "/TimesheetApproval",
        icon: { active: timesheetapp1, inactive: timesheetapp },
        permission: "View Timesheet Approve",
        matches: ["/TimesheetApproval"],
      },
    ],
  },

  // 25. Test Management
  {
    key: "testManagement",
    label: "Test Management",
    eventKey: "4",
    icon: { active: ActiveMan, inactive: taskmanag_icon },
    anyPermission: [
      "View Test Cases",
      "View Data Statistics",
      "View Test Un-Answered List",
    ],
    matches: ["/testCases", "/TestDataStatic", "/TestunAnsweredCase"],
    type: "accordion",
    items: [
      {
        label: "Test Cases",
        to: "/testCases",
        icon: { active: role1, inactive: role },
        permission: "View Test Cases",
        matches: ["/testCases"],
      },
      {
        label: "Test Un-Answered List",
        to: "/TestunAnsweredCase",
        icon: { active: role1, inactive: role },
        permission: "View Test Un-Answered List",
        matches: ["/TestunAnsweredCase"],
      },
    ],
  },

  // 26. Teams Management
  {
    key: "teamsManagement",
    label: "Teams Management",
    eventKey: "11",
    icon: { active: TeamsManagementActiveIcon, inactive: TeamsManagementIcon },
    permission: "View Create Team",
    matches: ["/CreateTeam", "/ManageTeam"],
    type: "accordion",
    items: [
      {
        label: "Create Team",
        to: "/CreateTeam",
        icon: { active: addTeam1, inactive: addTeam },
        permission: "View Create Team",
        matches: ["/CreateTeam"],
      },
      {
        label: "Manage Teams",
        to: "/ManageTeam",
        icon: { active: manageTeam1, inactive: manageTeam },
        permission: "View Manage Team",
        matches: ["/ManageTeam"],
      },
    ],
  },

  // 29. Workflow
  {
    key: "workflow",
    label: "Workflow",
    eventKey: "29",
    icon: { active: workflow, inactive: workflow },
    anyPermission: [
      "View Workflow Dashboard",
      "View Defined Workflow",
      "View Workflow Event Mapping",
      "View Completed Workflows",
      "View Workflow Trigger List",
    ],
    matches: [
      "/workflowDashboard",
      "/workFlowList",
      "/workflowEventMapping",
      "/subscriptionlist",
      "/completedworkflows",
      "/completedWorkflowTask",
      "/WorkFlowChartss",
    ],
    type: "accordion",
    items: [
      {
        label: "Completed Workflows",
        to: "/completedworkflows",
        permission: "View Completed Workflows",
        matches: ["/completedworkflows"],
      },
      {
        label: "Completed Workflow Task",
        to: "/completedWorkflowTask",
        permission: "View Completed Workflow Task",
        matches: ["/completedWorkflowTask"],
      },
      {
        label: "Completed Workflow Chart",
        to: "/WorkFlowChartss",
        permission: "View Completed Workflow Task",
        matches: ["/WorkFlowChartss"],
      },
      {
        label: "Defined Workflow",
        to: "/workFlowList",
        permission: "View Defined Workflow",
        matches: ["/workFlowList"],
      },
      {
        label: "Workflow Event Mapping",
        to: "/workflowEventMapping",
        permission: "View Workflow Event Mapping",
        matches: ["/workflowEventMapping"],
      },
      {
        label: "Workflow Trigger",
        to: "/subscriptionlist",
        permission: "View Workflow Trigger List",
        matches: ["/subscriptionlist"],
      },
    ],
  },
];

export default sidebarMenuConfig;
